const codes = ['BBAR', 'BARC'];

export const isBBAR = code => {
  return codes.includes(code);
};
